export const findParent = (el: HTMLElement, cond: (el: HTMLElement) => boolean): HTMLElement | null => {
  if (cond(el)) return el
  if (!el.parentElement || el.parentElement.tagName === 'BODY') return null
  return findParent(el.parentElement, cond)
}